/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 12',
    data: '<path d="M2.3 1H12.7C13.415 1 14 1.5625 14 2.25V9.75C14 10.4375 13.415 11 12.7 11H2.3C1.585 11 1 10.4375 1 9.75V2.25C1 1.5625 1.585 1 2.3 1Z" stroke="#00D87D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2.25L7.5 6.625L1 2.25" stroke="#00D87D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
